import { render, staticRenderFns } from "./DoctorCard.vue?vue&type=template&id=c40c6716&scoped=true&"
import script from "./DoctorCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorCard.vue?vue&type=style&index=0&id=c40c6716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40c6716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c40c6716')) {
      api.createRecord('c40c6716', component.options)
    } else {
      api.reload('c40c6716', component.options)
    }
    module.hot.accept("./DoctorCard.vue?vue&type=template&id=c40c6716&scoped=true&", function () {
      api.rerender('c40c6716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/memorial/MemoryBoardPage/components/DoctorCard.vue"
export default component.exports